import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Mail, MapPin, Phone } from "lucide-react";
import { NAV_LINKS } from "../data/content";
import { PillButton } from "./PillButton";

const socials = ["Twitter", "LinkedIn", "Instagram", "YouTube"];

export default function Footer() {
  return (
    <footer className="bg-[#0033A2] text-white overflow-hidden" data-testid="footer">
      {/* Massive CTA */}
      <div className="container-x pt-24 pb-16 border-b border-white/20">
        <p className="font-heading font-bold uppercase tracking-[0.25em] text-sm text-white/70 mb-6">
          Ready when you are
        </p>
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="font-heading font-black leading-[0.9] tracking-tighter text-[16vw] md:text-[11vw]"
        >
          Let's talk.
        </motion.h2>
        <div className="mt-8 flex flex-col sm:flex-row gap-4">
          <PillButton to="/contact" variant="white" testid="footer-cta-demo">
            Book a free demo <ArrowUpRight size={18} strokeWidth={2.5} />
          </PillButton>
          <PillButton
            href="mailto:hello@grooh.app"
            variant="white"
            testid="footer-cta-email"
            className="!bg-transparent !text-white !border-white !shadow-none hover:!bg-white hover:!text-[#0033A2]"
          >
            hello@grooh.app
          </PillButton>
        </div>
      </div>

      {/* Links */}
      <div className="container-x py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <span className="font-heading font-black text-3xl tracking-tighter">grooh.</span>
          <p className="mt-4 text-white/70 text-sm leading-relaxed max-w-xs">
            The all-in-one operating system for modern housing societies and gated communities.
          </p>
        </div>

        <div>
          <h4 className="font-heading font-bold uppercase tracking-widest text-xs text-white/60 mb-4">
            Pages
          </h4>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="text-white/85 hover:text-white font-medium transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold uppercase tracking-widest text-xs text-white/60 mb-4">
            Social
          </h4>
          <ul className="space-y-3">
            {socials.map((s) => (
              <li key={s}>
                <a
                  href="#"
                  className="text-white/85 hover:text-white font-medium transition-colors inline-flex items-center gap-1"
                >
                  {s} <ArrowUpRight size={14} />
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold uppercase tracking-widest text-xs text-white/60 mb-4">
            Reach us
          </h4>
          <ul className="space-y-3 text-white/85 font-medium text-sm">
            <li className="flex items-start gap-2"><Mail size={16} className="mt-0.5" /> hello@grooh.app</li>
            <li className="flex items-start gap-2"><Phone size={16} className="mt-0.5" /> +91 80 4718 2200</li>
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5" /> Indiranagar, Bengaluru, IN</li>
          </ul>
        </div>
      </div>

      <div className="container-x py-6 border-t border-white/20 flex flex-col sm:flex-row justify-between gap-3 text-white/60 text-sm">
        <p>© {new Date().getFullYear()} grooh Technologies. All rights reserved.</p>
        <div className="flex gap-6">
          <Link to="/privacy" className="hover:text-white">Privacy</Link>
          <Link to="/delete-account" className="hover:text-white">Delete Account</Link>
          <a href="#" className="hover:text-white">Terms</a>
        </div>
      </div>
    </footer>
  );
}
